require('./spine/server/event/event_filter_pb.js');
require('./spine/client/entities_pb.js');
require('./google/protobuf/source_context_pb.js');
require('./spine/core/enrichment_pb.js');
require('./spine/client/subscription_pb.js');
require('./spine/core/tenant_id_pb.js');
require('./spine/server/integration/integration_bus_pb.js');
require('./google/protobuf/type_pb.js');
require('./google/protobuf/descriptor_pb.js');
require('./spine/core/ack_pb.js');
require('./google/protobuf/duration_pb.js');
require('./spine/system/server/c/event_lifecycle_events_pb.js');
require('./spine/base/error_pb.js');
require('./spine/change/value_mismatch_pb.js');
require('./google/protobuf/field_mask_pb.js');
require('./spine/server/tenant/events_pb.js');
require('./spine/system/server/c/history_rejections_pb.js');
require('./google/protobuf/any_pb.js');
require('./spine/core/version_pb.js');
require('./spine/web/web_query_pb.js');
require('./spine/system/server/c/enrichments_pb.js');
require('./spine/system/server/command_lifecycle_pb.js');
require('./spine/net/email_address_pb.js');
require('./spine/base/field_filter_pb.js');
require('./spine/core/event_pb.js');
require('./spine/server/integration/channel_pb.js');
require('./google/protobuf/struct_pb.js');
require('./spine/system/server/c/history_events_pb.js');
require('./spine/server/event/event_stream_query_pb.js');
require('./spine/system/server/c/command_lifecycle_commands_pb.js');
require('./spine/validate/constraint_violation_pb.js');
require('./google/protobuf/api_pb.js');
require('./spine/system/server/q/mirror_pb.js');
require('./spine/system/server/c/event_lifecycle_commands_pb.js');
require('./spine/server/model/standard_events_pb.js');
require('./spine/options_pb.js');
require('./google/protobuf/empty_pb.js');
require('./spine/web/firebase/firebase_query_response_pb.js');
require('./spine/server/model/message_handler_pb.js');
require('./spine/server/entity/entity_pb.js');
require('./spine/net/internet_domain_pb.js');
require('./google/protobuf/compiler/plugin_pb.js');
require('./spine/system/server/c/command_lifecycle_events_pb.js');
require('./spine/system/server/q/scheduled_command_pb.js');
require('./spine/net/url_pb.js');
require('./spine/ui/color_pb.js');
require('./spine/core/user_id_pb.js');
require('./spine/validate/validation_error_pb.js');
require('./google/protobuf/timestamp_pb.js');
require('./spine/server/entity/standard_rejections_pb.js');
require('./spine/change/change_pb.js');
require('./spine/system/server/entity_history_pb.js');
require('./spine/time/time_pb.js');
require('./spine/server/aggregate/aggregate_pb.js');
require('./spine/system/server/c/history_commands_pb.js');
require('./spine/server/delivery/delivery_pb.js');
require('./spine/core/response_pb.js');
require('./google/protobuf/wrappers_pb.js');
require('./spine/core/actor_context_pb.js');
require('./spine/core/bounded_context_pb.js');
require('./spine/people/person_name_pb.js');
require('./spine/core/command_pb.js');
require('./spine/client/query_pb.js');
require('./spine/base/field_path_pb.js');
require('./spine/time/time_change_pb.js');

module.exports.types = new Map([
  ['type.spine.io/spine.server.entity.EntityRecord', proto.spine.server.entity.EntityRecord],
  ['type.spine.io/spine.server.entity.LifecycleFlags', proto.spine.server.entity.LifecycleFlags],
  ['type.spine.io/spine.server.entity.EntityRecordChange', proto.spine.server.entity.EntityRecordChange],
  ['type.spine.io/spine.server.model.HandlerId', proto.spine.server.model.HandlerId],
  ['type.spine.io/spine.server.model.HandlerTypeInfo', proto.spine.server.model.HandlerTypeInfo],
  ['type.spine.io/spine.server.model.MessageFilter', proto.spine.server.model.MessageFilter],
  ['type.googleapis.com/google.protobuf.DoubleValue', proto.google.protobuf.DoubleValue],
  ['type.googleapis.com/google.protobuf.FloatValue', proto.google.protobuf.FloatValue],
  ['type.googleapis.com/google.protobuf.Int64Value', proto.google.protobuf.Int64Value],
  ['type.googleapis.com/google.protobuf.UInt64Value', proto.google.protobuf.UInt64Value],
  ['type.googleapis.com/google.protobuf.Int32Value', proto.google.protobuf.Int32Value],
  ['type.googleapis.com/google.protobuf.UInt32Value', proto.google.protobuf.UInt32Value],
  ['type.googleapis.com/google.protobuf.BoolValue', proto.google.protobuf.BoolValue],
  ['type.googleapis.com/google.protobuf.StringValue', proto.google.protobuf.StringValue],
  ['type.googleapis.com/google.protobuf.BytesValue', proto.google.protobuf.BytesValue],
  ['type.spine.io/spine.server.model.Nothing', proto.spine.server.model.Nothing],
  ['type.spine.io/IfMissingOption', proto.IfMissingOption],
  ['type.spine.io/DecimalMinOption', proto.DecimalMinOption],
  ['type.spine.io/DecimalMaxOption', proto.DecimalMaxOption],
  ['type.spine.io/MinOption', proto.MinOption],
  ['type.spine.io/MaxOption', proto.MaxOption],
  ['type.spine.io/DigitsOption', proto.DigitsOption],
  ['type.spine.io/TimeOption', proto.TimeOption],
  ['type.spine.io/PatternOption', proto.PatternOption],
  ['type.spine.io/IfInvalidOption', proto.IfInvalidOption],
  ['type.spine.io/GoesOption', proto.GoesOption],
  ['type.spine.io/EntityOption', proto.EntityOption],
  ['type.spine.io/spine.net.InternetDomain', proto.spine.net.InternetDomain],
  ['type.googleapis.com/google.protobuf.Empty', proto.google.protobuf.Empty],
  ['type.spine.io/spine.core.Version', proto.spine.core.Version],
  ['type.spine.io/spine.core.EventId', proto.spine.core.EventId],
  ['type.spine.io/spine.core.Event', proto.spine.core.Event],
  ['type.spine.io/spine.core.EventContext', proto.spine.core.EventContext],
  ['type.spine.io/spine.core.RejectionEventContext', proto.spine.core.RejectionEventContext],
  ['type.spine.io/spine.core.Response', proto.spine.core.Response],
  ['type.spine.io/spine.core.Status', proto.spine.core.Status],
  ['type.googleapis.com/google.protobuf.Timestamp', proto.google.protobuf.Timestamp],
  ['type.spine.io/spine.client.QueryId', proto.spine.client.QueryId],
  ['type.spine.io/spine.client.OrderBy', proto.spine.client.OrderBy],
  ['type.spine.io/spine.client.Pagination', proto.spine.client.Pagination],
  ['type.spine.io/spine.client.Query', proto.spine.client.Query],
  ['type.spine.io/spine.client.QueryResponse', proto.spine.client.QueryResponse],
  ['type.spine.io/spine.system.server.EntityHistoryId', proto.spine.system.server.EntityHistoryId],
  ['type.spine.io/spine.system.server.EntityHistory', proto.spine.system.server.EntityHistory],
  ['type.spine.io/spine.system.server.LifecycleHistory', proto.spine.system.server.LifecycleHistory],
  ['type.spine.io/spine.system.server.DispatchingHistory', proto.spine.system.server.DispatchingHistory],
  ['type.spine.io/spine.system.server.DispatchedMessageId', proto.spine.system.server.DispatchedMessageId],
  ['type.spine.io/spine.ui.Color', proto.spine.ui.Color],
  ['type.googleapis.com/google.protobuf.Any', proto.google.protobuf.Any],
  ['type.spine.io/spine.net.Url', proto.spine.net.Url],
  ['type.spine.io/spine.net.Uri', proto.spine.net.Uri],
  ['type.spine.io/spine.base.Error', proto.spine.base.Error],
  ['type.spine.io/spine.core.BoundedContextName', proto.spine.core.BoundedContextName],
  ['type.spine.io/spine.server.event.EventStreamQuery', proto.spine.server.event.EventStreamQuery],
  ['type.spine.io/spine.validate.ValidationError', proto.spine.validate.ValidationError],
  ['type.spine.io/spine.server.integration.ExternalMessage', proto.spine.server.integration.ExternalMessage],
  ['type.spine.io/spine.server.integration.RequestForExternalMessages', proto.spine.server.integration.RequestForExternalMessages],
  ['type.spine.io/spine.server.integration.ExternalMessageType', proto.spine.server.integration.ExternalMessageType],
  ['type.spine.io/spine.system.server.CommandLifecycle', proto.spine.system.server.CommandLifecycle],
  ['type.spine.io/spine.system.server.CommandTarget', proto.spine.system.server.CommandTarget],
  ['type.spine.io/spine.system.server.CommandTimeline', proto.spine.system.server.CommandTimeline],
  ['type.spine.io/spine.system.server.Substituted', proto.spine.system.server.Substituted],
  ['type.spine.io/spine.change.ValueMismatch', proto.spine.change.ValueMismatch],
  ['type.spine.io/spine.client.TopicId', proto.spine.client.TopicId],
  ['type.spine.io/spine.client.Topic', proto.spine.client.Topic],
  ['type.spine.io/spine.client.SubscriptionUpdate', proto.spine.client.SubscriptionUpdate],
  ['type.spine.io/spine.client.EntityStateUpdate', proto.spine.client.EntityStateUpdate],
  ['type.spine.io/spine.client.SubscriptionId', proto.spine.client.SubscriptionId],
  ['type.spine.io/spine.client.Subscription', proto.spine.client.Subscription],
  ['type.spine.io/spine.core.UserId', proto.spine.core.UserId],
  ['type.spine.io/spine.core.Enrichment', proto.spine.core.Enrichment],
  ['type.spine.io/spine.web.firebase.FirebaseQueryResponse', proto.spine.web.firebase.FirebaseQueryResponse],
  ['type.spine.io/spine.system.server.ScheduledCommandRecord', proto.spine.system.server.ScheduledCommandRecord],
  ['type.spine.io/spine.system.server.CommandReceived', proto.spine.system.server.CommandReceived],
  ['type.spine.io/spine.system.server.CommandAcknowledged', proto.spine.system.server.CommandAcknowledged],
  ['type.spine.io/spine.system.server.CommandScheduled', proto.spine.system.server.CommandScheduled],
  ['type.spine.io/spine.system.server.CommandDispatched', proto.spine.system.server.CommandDispatched],
  ['type.spine.io/spine.system.server.TargetAssignedToCommand', proto.spine.system.server.TargetAssignedToCommand],
  ['type.spine.io/spine.system.server.CommandHandled', proto.spine.system.server.CommandHandled],
  ['type.spine.io/spine.system.server.CommandErrored', proto.spine.system.server.CommandErrored],
  ['type.spine.io/spine.system.server.CommandRejected', proto.spine.system.server.CommandRejected],
  ['type.spine.io/spine.system.server.CommandTransformed', proto.spine.system.server.CommandTransformed],
  ['type.spine.io/spine.system.server.CommandSplit', proto.spine.system.server.CommandSplit],
  ['type.spine.io/spine.system.server.Mirror', proto.spine.system.server.Mirror],
  ['type.spine.io/spine.system.server.MirrorId', proto.spine.system.server.MirrorId],
  ['type.spine.io/spine.system.server.EntityColumns', proto.spine.system.server.EntityColumns],
  ['type.spine.io/spine.base.FieldFilter', proto.spine.base.FieldFilter],
  ['type.spine.io/spine.system.server.ScheduleCommand', proto.spine.system.server.ScheduleCommand],
  ['type.spine.io/spine.system.server.AssignTargetToCommand', proto.spine.system.server.AssignTargetToCommand],
  ['type.googleapis.com/google.protobuf.Duration', proto.google.protobuf.Duration],
  ['type.googleapis.com/google.protobuf.Type', proto.google.protobuf.Type],
  ['type.googleapis.com/google.protobuf.Field', proto.google.protobuf.Field],
  ['type.googleapis.com/google.protobuf.Enum', proto.google.protobuf.Enum],
  ['type.googleapis.com/google.protobuf.EnumValue', proto.google.protobuf.EnumValue],
  ['type.googleapis.com/google.protobuf.Option', proto.google.protobuf.Option],
  ['type.spine.io/spine.server.aggregate.Snapshot', proto.spine.server.aggregate.Snapshot],
  ['type.spine.io/spine.server.aggregate.AggregateEventRecord', proto.spine.server.aggregate.AggregateEventRecord],
  ['type.spine.io/spine.server.aggregate.AggregateStateRecord', proto.spine.server.aggregate.AggregateStateRecord],
  ['type.spine.io/spine.system.server.DispatchEventToSubscriber', proto.spine.system.server.DispatchEventToSubscriber],
  ['type.spine.io/spine.system.server.DispatchEventToReactor', proto.spine.system.server.DispatchEventToReactor],
  ['type.spine.io/spine.system.server.DispatchCommandToHandler', proto.spine.system.server.DispatchCommandToHandler],
  ['type.googleapis.com/google.protobuf.FileDescriptorSet', proto.google.protobuf.FileDescriptorSet],
  ['type.googleapis.com/google.protobuf.FileDescriptorProto', proto.google.protobuf.FileDescriptorProto],
  ['type.googleapis.com/google.protobuf.DescriptorProto', proto.google.protobuf.DescriptorProto],
  ['type.googleapis.com/google.protobuf.ExtensionRangeOptions', proto.google.protobuf.ExtensionRangeOptions],
  ['type.googleapis.com/google.protobuf.FieldDescriptorProto', proto.google.protobuf.FieldDescriptorProto],
  ['type.googleapis.com/google.protobuf.OneofDescriptorProto', proto.google.protobuf.OneofDescriptorProto],
  ['type.googleapis.com/google.protobuf.EnumDescriptorProto', proto.google.protobuf.EnumDescriptorProto],
  ['type.googleapis.com/google.protobuf.EnumValueDescriptorProto', proto.google.protobuf.EnumValueDescriptorProto],
  ['type.googleapis.com/google.protobuf.ServiceDescriptorProto', proto.google.protobuf.ServiceDescriptorProto],
  ['type.googleapis.com/google.protobuf.MethodDescriptorProto', proto.google.protobuf.MethodDescriptorProto],
  ['type.googleapis.com/google.protobuf.FileOptions', proto.google.protobuf.FileOptions],
  ['type.googleapis.com/google.protobuf.MessageOptions', proto.google.protobuf.MessageOptions],
  ['type.googleapis.com/google.protobuf.FieldOptions', proto.google.protobuf.FieldOptions],
  ['type.googleapis.com/google.protobuf.OneofOptions', proto.google.protobuf.OneofOptions],
  ['type.googleapis.com/google.protobuf.EnumOptions', proto.google.protobuf.EnumOptions],
  ['type.googleapis.com/google.protobuf.EnumValueOptions', proto.google.protobuf.EnumValueOptions],
  ['type.googleapis.com/google.protobuf.ServiceOptions', proto.google.protobuf.ServiceOptions],
  ['type.googleapis.com/google.protobuf.MethodOptions', proto.google.protobuf.MethodOptions],
  ['type.googleapis.com/google.protobuf.UninterpretedOption', proto.google.protobuf.UninterpretedOption],
  ['type.googleapis.com/google.protobuf.SourceCodeInfo', proto.google.protobuf.SourceCodeInfo],
  ['type.googleapis.com/google.protobuf.GeneratedCodeInfo', proto.google.protobuf.GeneratedCodeInfo],
  ['type.spine.io/spine.server.event.EventFilter', proto.spine.server.event.EventFilter],
  ['type.spine.io/spine.core.TenantId', proto.spine.core.TenantId],
  ['type.spine.io/spine.validate.ConstraintViolation', proto.spine.validate.ConstraintViolation],
  ['type.googleapis.com/google.protobuf.Api', proto.google.protobuf.Api],
  ['type.googleapis.com/google.protobuf.Method', proto.google.protobuf.Method],
  ['type.googleapis.com/google.protobuf.Mixin', proto.google.protobuf.Mixin],
  ['type.spine.io/spine.base.FieldPath', proto.spine.base.FieldPath],
  ['type.spine.io/spine.people.PersonName', proto.spine.people.PersonName],
  ['type.spine.io/spine.time.LocalDateChange', proto.spine.time.LocalDateChange],
  ['type.spine.io/spine.time.LocalTimeChange', proto.spine.time.LocalTimeChange],
  ['type.spine.io/spine.time.OffsetTimeChange', proto.spine.time.OffsetTimeChange],
  ['type.spine.io/spine.time.OffsetDateTimeChange', proto.spine.time.OffsetDateTimeChange],
  ['type.spine.io/spine.web.WebQuery', proto.spine.web.WebQuery],
  ['type.googleapis.com/google.protobuf.SourceContext', proto.google.protobuf.SourceContext],
  ['type.googleapis.com/google.protobuf.Struct', proto.google.protobuf.Struct],
  ['type.googleapis.com/google.protobuf.Value', proto.google.protobuf.Value],
  ['type.googleapis.com/google.protobuf.ListValue', proto.google.protobuf.ListValue],
  ['type.spine.io/spine.net.EmailAddress', proto.spine.net.EmailAddress],
  ['type.spine.io/spine.server.delivery.ConsumerId', proto.spine.server.delivery.ConsumerId],
  ['type.spine.io/spine.server.delivery.ShardedMessageId', proto.spine.server.delivery.ShardedMessageId],
  ['type.spine.io/spine.server.delivery.ShardedMessage', proto.spine.server.delivery.ShardedMessage],
  ['type.spine.io/spine.server.delivery.ShardIndex', proto.spine.server.delivery.ShardIndex],
  ['type.spine.io/spine.client.EntityId', proto.spine.client.EntityId],
  ['type.spine.io/spine.client.Target', proto.spine.client.Target],
  ['type.spine.io/spine.client.EntityFilters', proto.spine.client.EntityFilters],
  ['type.spine.io/spine.client.CompositeColumnFilter', proto.spine.client.CompositeColumnFilter],
  ['type.spine.io/spine.client.ColumnFilter', proto.spine.client.ColumnFilter],
  ['type.spine.io/spine.client.EntityIdFilter', proto.spine.client.EntityIdFilter],
  ['type.spine.io/spine.core.CommandId', proto.spine.core.CommandId],
  ['type.spine.io/spine.core.Command', proto.spine.core.Command],
  ['type.spine.io/spine.core.CommandContext', proto.spine.core.CommandContext],
  ['type.spine.io/spine.core.DispatchedCommand', proto.spine.core.DispatchedCommand],
  ['type.spine.io/spine.system.server.MarkCausedCommand', proto.spine.system.server.MarkCausedCommand],
  ['type.spine.io/spine.system.server.MarkCausedCommands', proto.spine.system.server.MarkCausedCommands],
  ['type.spine.io/spine.system.server.CommandEnrichment', proto.spine.system.server.CommandEnrichment],
  ['type.spine.io/spine.core.ActorContext', proto.spine.core.ActorContext],
  ['type.spine.io/spine.server.integration.ChannelId', proto.spine.server.integration.ChannelId],
  ['type.spine.io/spine.system.server.EntityCreated', proto.spine.system.server.EntityCreated],
  ['type.spine.io/spine.system.server.EventDispatchedToSubscriber', proto.spine.system.server.EventDispatchedToSubscriber],
  ['type.spine.io/spine.system.server.EventDispatchedToReactor', proto.spine.system.server.EventDispatchedToReactor],
  ['type.spine.io/spine.system.server.CommandDispatchedToHandler', proto.spine.system.server.CommandDispatchedToHandler],
  ['type.spine.io/spine.system.server.EventImported', proto.spine.system.server.EventImported],
  ['type.spine.io/spine.system.server.EntityStateChanged', proto.spine.system.server.EntityStateChanged],
  ['type.spine.io/spine.system.server.EntityArchived', proto.spine.system.server.EntityArchived],
  ['type.spine.io/spine.system.server.EntityDeleted', proto.spine.system.server.EntityDeleted],
  ['type.spine.io/spine.system.server.EntityExtractedFromArchive', proto.spine.system.server.EntityExtractedFromArchive],
  ['type.spine.io/spine.system.server.EntityRestored', proto.spine.system.server.EntityRestored],
  ['type.spine.io/spine.system.server.EventCausedCommand', proto.spine.system.server.EventCausedCommand],
  ['type.spine.io/spine.system.server.EventCausedCommands', proto.spine.system.server.EventCausedCommands],
  ['type.spine.io/spine.server.tenant.TenantAdded', proto.spine.server.tenant.TenantAdded],
  ['type.googleapis.com/google.protobuf.FieldMask', proto.google.protobuf.FieldMask],
  ['type.spine.io/spine.time.YearMonth', proto.spine.time.YearMonth],
  ['type.spine.io/spine.time.LocalDate', proto.spine.time.LocalDate],
  ['type.spine.io/spine.time.LocalTime', proto.spine.time.LocalTime],
  ['type.spine.io/spine.time.LocalDateTime', proto.spine.time.LocalDateTime],
  ['type.spine.io/spine.time.ZoneOffset', proto.spine.time.ZoneOffset],
  ['type.spine.io/spine.time.OffsetTime', proto.spine.time.OffsetTime],
  ['type.spine.io/spine.time.OffsetDateTime', proto.spine.time.OffsetDateTime],
  ['type.spine.io/spine.time.ZoneId', proto.spine.time.ZoneId],
  ['type.spine.io/spine.time.ZonedDateTime', proto.spine.time.ZonedDateTime],
  ['type.spine.io/spine.server.entity.CannotModifyArchivedEntity', proto.spine.server.entity.CannotModifyArchivedEntity],
  ['type.spine.io/spine.server.entity.CannotModifyDeletedEntity', proto.spine.server.entity.CannotModifyDeletedEntity],
  ['type.spine.io/spine.server.entity.EntityAlreadyArchived', proto.spine.server.entity.EntityAlreadyArchived],
  ['type.spine.io/spine.server.entity.EntityAlreadyDeleted', proto.spine.server.entity.EntityAlreadyDeleted],
  ['type.spine.io/spine.core.Ack', proto.spine.core.Ack],
  ['type.spine.io/spine.change.StringChange', proto.spine.change.StringChange],
  ['type.spine.io/spine.change.TimestampChange', proto.spine.change.TimestampChange],
  ['type.spine.io/spine.change.DoubleChange', proto.spine.change.DoubleChange],
  ['type.spine.io/spine.change.FloatChange', proto.spine.change.FloatChange],
  ['type.spine.io/spine.change.Int32Change', proto.spine.change.Int32Change],
  ['type.spine.io/spine.change.Int64Change', proto.spine.change.Int64Change],
  ['type.spine.io/spine.change.UInt32Change', proto.spine.change.UInt32Change],
  ['type.spine.io/spine.change.UInt64Change', proto.spine.change.UInt64Change],
  ['type.spine.io/spine.change.SInt32Change', proto.spine.change.SInt32Change],
  ['type.spine.io/spine.change.SInt64Change', proto.spine.change.SInt64Change],
  ['type.spine.io/spine.change.Fixed32Change', proto.spine.change.Fixed32Change],
  ['type.spine.io/spine.change.Fixed64Change', proto.spine.change.Fixed64Change],
  ['type.spine.io/spine.change.Sfixed32Change', proto.spine.change.Sfixed32Change],
  ['type.spine.io/spine.change.Sfixed64Change', proto.spine.change.Sfixed64Change],
  ['type.spine.io/spine.change.BooleanChange', proto.spine.change.BooleanChange],
  ['type.spine.io/spine.change.BytesChange', proto.spine.change.BytesChange],
  ['type.googleapis.com/google.protobuf.compiler.Version', proto.google.protobuf.compiler.Version],
  ['type.googleapis.com/google.protobuf.compiler.CodeGeneratorRequest', proto.google.protobuf.compiler.CodeGeneratorRequest],
  ['type.googleapis.com/google.protobuf.compiler.CodeGeneratorResponse', proto.google.protobuf.compiler.CodeGeneratorResponse],
  ['type.spine.io/spine.system.server.CannotDispatchEventTwice', proto.spine.system.server.CannotDispatchEventTwice],
  ['type.spine.io/spine.system.server.CannotDispatchCommandTwice', proto.spine.system.server.CannotDispatchCommandTwice]
]);
